module.exports = __webpack_public_path__ + "static/media/chat05.0d5f563e.png";